/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// App Requires
require('./app/team-filters');
require('./app/career-filters');
require('./app/nav-indicators');
require('./app/modal');
require('./app/primary-navigation');
require('./app/smooth-scroll');
//require('./app/feature-slider');

// GSAP
require('./app/gsap/expanding-cards');
require('./app/gsap/general-animation');
